/**
 * Компонент для плавных переходов между экранами
 */

import { ReactNode, useEffect, useState } from 'react';
import styles from './ScreenTransition.module.css';

interface ScreenTransitionProps {
  /** Дочерние элементы */
  children: ReactNode;
  /** Ключ для определения смены контента */
  transitionKey: string;
}

/**
 * Обеспечивает плавный fade переход между экранами
 */
export function ScreenTransition({ children, transitionKey }: ScreenTransitionProps) {
  const [displayChildren, setDisplayChildren] = useState(children);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [prevKey, setPrevKey] = useState(transitionKey);

  useEffect(() => {
    // Анимация только если transitionKey ИЗМЕНИЛСЯ (не при изменении children)
    if (transitionKey !== prevKey) {
      setIsTransitioning(true);
      setPrevKey(transitionKey);

      const timer = setTimeout(() => {
        setDisplayChildren(children);
        setIsTransitioning(false);
      }, 200); // Половина анимации

      return () => clearTimeout(timer);
    } else {
      // Если transitionKey тот же, просто обновляем children без анимации
      setDisplayChildren(children);
    }
  }, [transitionKey, children, prevKey]);

  return (
    <div className={`${styles.transition} ${isTransitioning ? styles.fadeOut : styles.fadeIn}`}>
      {displayChildren}
    </div>
  );
}

